import React, { useEffect } from "react";
import { Provider } from "react-redux";
import AppRouter from "./Routers";
import { Persistor, Store } from "./common/configureStore";
import CommonTheme from "./common/commonTheme";
import SocketHandler from "./common/socket/socketHandler";
import AuthService from "./common/services/auth-service";
import { CartWatcherService } from "./common/services/cart-watcher-service";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FirebaseAppProvider from "./firebase/firebase-app-service";
import FirebaseAnalyticsProvider from "./firebase/analytics/firebase-analytics-service";
import { PersistGate } from "redux-persist/integration/react";
import InternetConnectivityChecker from "./components/InternetConnectivityChecker/InternetConnectivityChecker";
import "./App.scss";
import Loader from "./components/Loader";
import { deleteCookie, getCookie } from "./helper/cookieHelper";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID } from "./common/constants";
import { get } from "react-hook-form";

function App() {

  const userDetails = getCookie(USER_DETAILS)
  const userId = getCookie(USER_ID);

  //Checking if it is a new customer
  useEffect(() => {
    if(!userDetails || !userDetails?.firstName || !userDetails?.customerId || !userId){
      deleteCookie(USER_DETAILS)
      deleteCookie(USER_ID)
      deleteCookie(ACCESS_TOKEN);
    }
  }, [])

  //To prevent right click outside editable fields
  useEffect(() => {
    const handleContextmenu = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (target) {
        const tagName = target.tagName;
        const isEditable =
          target.isContentEditable ||
          tagName === "INPUT" ||
          tagName === "TEXTAREA" ||
          (tagName === "BUTTON" && target.getAttribute("type") === "submit");

        if (isEditable) {
          return;
        }
      }

      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextmenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, [])

  return (
    <Provider store={Store}>
      <PersistGate loading={<Loader/>} persistor={Persistor}>
        <HelmetProvider>
          <InternetConnectivityChecker>
            <div className="psuduoRoute">
              <div id="innerContainer">
                <AuthService>
                  <FirebaseAppProvider>
                    <FirebaseAnalyticsProvider>
                      <SocketHandler>
                        <>
                          <ToastContainer
                            autoClose={3000}
                            toastClassName="custom-toast"
                            // className={isMobile ? "custom-toast-container" : "custom-toast-container-desktop"}
                            closeButton={false}
                            hideProgressBar={true}
                            icon={false}
                          />
                          <CommonTheme />
                          <CartWatcherService />
                          <AppRouter />
                        </>
                      </SocketHandler>
                    </FirebaseAnalyticsProvider>
                  </FirebaseAppProvider>
                </AuthService>
              </div>
            </div>
          </InternetConnectivityChecker>
        </HelmetProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
